var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      class: ["cargo-dialog", _vm.minSize ? "minSize" : ""],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: _vm.minSize ? "240px" : _vm.width,
        top: _vm.top,
        "custom-class": _vm.customClass,
        fullscreen: _vm.fullscreen,
        modal: false,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticClass: "cargo-dialog__header" }, [
          _c(
            "div",
            { staticClass: "title" },
            [_vm._t("title", [_vm._v(" " + _vm._s(_vm.title) + " ")])],
            2
          ),
          _c("div", { staticClass: "operation" }, [
            _vm.canMinimize && !_vm.minSize
              ? _c("i", {
                  staticClass: "el-icon-minus",
                  on: { click: _vm.onModalMin }
                })
              : _vm._e(),
            _vm.onlyCanMinimize && _vm.onlyCanMin
              ? _c("i", {
                  class: "el-icon-full-screen",
                  staticStyle: { padding: "0 5px" },
                  on: { click: _vm.onModalPlus }
                })
              : _vm._e(),
            !_vm.onlyCanMinimize && (_vm.canMaximize || _vm.canMinimize)
              ? _c("i", {
                  class:
                    !_vm.fullscreen || _vm.minSize
                      ? "el-icon-full-screen"
                      : "el-icon-copy-document",
                  staticStyle: { padding: "0 5px" },
                  on: { click: _vm.onModalPlus }
                })
              : _vm._e(),
            _c("i", {
              staticClass: "el-icon-close",
              on: { click: _vm.handleClose }
            })
          ])
        ])
      ]),
      _vm._t("default"),
      !_vm.minSize
        ? _c("template", { slot: "footer" }, [_vm._t("footer")], 2)
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }